export default __webpack_public_path__ + "static/media/visa-logo-official.a05453b4.png";